import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initBlogPagination from '../sections/blog/initBlogPagination';

ready(() => {
  initBlogPagination();
});

onShopifySectionLoad(() => {    
  initBlogPagination();
});
